import { useEffect, useMemo, useState } from 'react';

function parseTarget(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (!isNaN(d)) return d;
  // fallback for odd formats
  const f = new Date(iso.replace(/-/g, '/'));
  return isNaN(f) ? null : f;
}

function diffParts(target) {
  let diff = target - new Date();
  if (diff < 0) diff = 0;
  const s = Math.floor(diff / 1000);
  const days = Math.floor(s / 86400);
  const hours = Math.floor((s % 86400) / 3600);
  const minutes = Math.floor((s % 3600) / 60);
  const seconds = s % 60;
  return { days, hours, minutes, seconds };
}

export default function Countdown({ targetISO }) {
  const target = useMemo(() => parseTarget(targetISO), [targetISO]);
  const [t, setT] = useState(target ? diffParts(target) : { days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    if (!target) return;
    const tick = () => setT(diffParts(target));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [target]);

  if (!target) return null;

  const pad = (n) => String(n).padStart(2, '0');

  const isOver = target && target < new Date();

  return (
  <div id="clock" className="time-count">
    {isOver ? (
      <div className="text-muted">Das Festival ist vorbei – bis zum nächsten Jahr!</div>
    ) : (
            <div id="clock" className="time-count">
                <div className="time-entry days"><span>{t.days}</span> Tage</div>
                <div className="time-entry hours"><span>{pad(t.hours)}</span> Stunden</div>
                <div className="time-entry minutes"><span>{pad(t.minutes)}</span> Minuten</div>
                <div className="time-entry seconds"><span>{pad(t.seconds)}</span> Sekunden</div>
            </div>
    )}
  </div>
);
}
